module.exports = __webpack_public_path__ + "img/max_visitor.6c1786ee.svg";